import { apiService } from '../APIService';

const PATH = '/news';

export default {
  getPublicNewsAll(params) {
    return apiService.get('public/news', params);
  },

  getPublicNews(id, params) {
    return apiService.get(`public/news/${id}`, params);
  },

  // from CRUD

  getAll(params) {
    return apiService.get(PATH, params);
  },

  get(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },

  create(payload) {
    return apiService.post(PATH, payload);
  },

  update(id, payload) {
    return apiService.put(`${PATH}/${id}`, payload);
  },

  delete(id) {
    return apiService.delete(`${PATH}/${id}`);
  },

  deleteAll(payload) {
    return apiService.delete(PATH, payload);
  },
};
